import { Api } from '../api/root-api';
import { GetBankAccountResponse } from '../bank-account';
import {
  CreateBankAccountRequest,
  CreateUpiIdRequest,
  DeleteBankAccountRequest,
  DeleteUpiIdRequest,
  GetAccountsRequest,
  GetAccountsReponse,
  GetOneAccountRequest,
  HealtApiRequest,
  GetBillingSummaryRequest,
  GetBillingSummaryResponse,
} from './model';

export const bankDetailsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createBankAccount: builder.mutation<any, CreateBankAccountRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/bankaccount/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    createUpiId: builder.mutation<any, CreateUpiIdRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/upi/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          body: args.body,
          params: args.params,
        };
      },
    }),
    getAccounts: builder.mutation<GetAccountsReponse, GetAccountsRequest>({
      query(args) {
        const { sellerWorkspaceId, workspaceId } = args?.params;
        return {
          url: `hub/orgs/api/accounts/${sellerWorkspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: { workspaceId },
        };
      },
    }),
    getOneAccount: builder.query<any, GetOneAccountRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/account/${args.params.sellerWorkspaceId}`,
          method: 'GET',
          params: args.params,
        };
      },
    }),
    deleteBankAccount: builder.query<any, DeleteBankAccountRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/bankaccount/${args.params.sellerWorkspaceId}/${args.id}`,
          method: 'DELETE',
          params: args.params,
        };
      },
    }),
    deleteUpiId: builder.query<any, DeleteUpiIdRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/upi/${args.params.sellerWorkspaceId}/${args.id}`,
          method: 'DELETE',
          params: args.params,
        };
      },
    }),
    healthApi: builder.query<any, HealtApiRequest>({
      query(args) {
        return {
          url: `hub/orgs/api/account/health/${args.params.sellerWorkspaceId}`,
          method: 'GET',
          params: args.params,
        };
      },
    }),
    getBillingSummary: builder.mutation<
      GetBillingSummaryResponse,
      GetBillingSummaryRequest
    >({
      query(args) {
        return {
          url: `hub/rewards-vault/api/billing/summary/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
          body: args.body,
        };
      },
    }),
  }),
});

export const {
  useCreateBankAccountMutation,
  useCreateUpiIdMutation,
  useGetAccountsMutation,
  useLazyGetOneAccountQuery,
  useLazyDeleteBankAccountQuery,
  useLazyDeleteUpiIdQuery,
  useLazyHealthApiQuery,
  useGetBillingSummaryMutation,
} = bankDetailsApi;
